import { PageMessageService } from '../services/page-message-service';
import { WebApiService } from '../services/web-api-service';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';

@autoinject()
export class LoginController {
    //public pageTitle: string;
    //constructor(
    //    private api: WebApiService,
    //    private router: Router,
    //    private pageMessageService: PageMessageService) {
    //}

    //navigatedFromFailedLogin: boolean;
    //email: string;
    //password: string;

    //login(email: string, password: string): Promise<any> {
    //    return this.api.post("Auth", "Login", { email: email, password: password });
    //}
    //logout(): Promise<any> {
    //    return this.api.post("Auth", "Logout");
    //}

    //requestAccount(reason: string, phone: string): any {
    //    return this.api.post("Auth", "RequestAccount", { email: reason, password: phone });
    //}

    //sendResetPasswordEmail(email: string) {
    //    this.pageMessageService.clear();
    //    return this.api.get("Auth", "SendResetPasswordEmail", { email: email })
    //        .then(() => {
    //            this.pageMessageService.setInfoMessage("An email has been sent containing a confirmation link to reset your password.");
    //        })
    //}

    //confirm(email: string, userId: string, confirmationCode: string, password: string): Promise<any> {
    //    this.pageMessageService.clear();
    //    return this.api.post("Auth", "ConfirmAccount", { userId: userId, confirmationCode: confirmationCode, password: password })
    //        .then(() => {
    //            this.email = email;
    //            this.router.navigate("login");

    //            this.pageMessageService.setInfoMessage("Your account has been confirmed.  You may log in using your new password.");
    //        })
    //        .catch((e) => {
    //            if (e.errorMessage) {
    //                this.pageMessageService.setErrorMessage(e.errorMessage);
    //            } else {
    //                this.pageMessageService.setErrorMessage("There was an issue confirming your account.  Please contact Nucor Logistics for assistance.");
    //            }
    //        });
    //}


    //resetPassword(email: string, userId: string, token: string, password: string): Promise<any> {
    //    this.pageMessageService.clear();
    //    return this.api.post("Auth", "ResetPassword", { userId: userId, token: token, password: password })
    //        .then(() => {
    //            this.email = email;
    //            this.router.navigate("login");

    //            this.pageMessageService.setInfoMessage("Your password has been reset.  You may log in using your new password.");
    //        })
    //        .catch((e) => {
    //            if (e.errorMessage) {
    //                this.pageMessageService.setErrorMessage(e.errorMessage);
    //            } else {
    //                this.pageMessageService.setErrorMessage("There was an issue resetting your password.  Please contact Nucor Logistics for assistance.");
    //            }
    //        });
    //}

    //changePassword(currentPassword: string, newPassword: string): Promise<void> {
    //    return this.api.post("Auth", "ChangePassword", { currentPassword: currentPassword, newPassword: newPassword })
    //        .then(() => {
    //            // this.email = email;
    //            this.router.navigate("login");

    //            this.pageMessageService.setInfoMessage("Your password has been changed.  You may log in using your new password.");
    //        })
    //        .catch((e) => {
    //            if (e.errorMessage) {
    //                this.pageMessageService.setErrorMessage(e.errorMessage);
    //            } else {
    //                this.pageMessageService.setErrorMessage("There was an issue changing your password.  Please contact Nucor Logistics for assistance.");
    //            }
    //        });
    //}
}


